import { render } from "./product-about.html?vue&type=template&id=06b2482b"
import script from "./ProductAbout.vue?vue&type=script&lang=ts"
export * from "./ProductAbout.vue?vue&type=script&lang=ts"

import "./product-about.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script